var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSerpsIcon = function SvgSerpsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.5,
    r: 15.5,
    fill: "#FF2E5B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.102,
    cy: 14.87,
    r: 4.875,
    fill: "#5B3552",
    transform: "rotate(-90 15.102 14.87)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.101,
    cy: 14.87,
    r: 7.376,
    stroke: "#fff",
    strokeWidth: 2,
    transform: "rotate(-41.245 15.101 14.87)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m19.984 20.44 3.855 4.397"
  })));
};
export { SvgSerpsIcon as ReactComponent };
export default __webpack_public_path__ + "images/SERPS_icon.svg";